import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterHotelBbPage() {
  return <ClusterPageTemplate clusterName="Hotel & B&B" sectorName="Horeca & Hospitality" sectorSlug="horeca-hospitality" heroTitle="Website laten maken voor een Hotel of B&B" heroDescription="Een gastvrije, visueel aantrekkelijke website voor jouw accommodatie. Wij bouwen websites die de commissies van boekingssites verlagen door directe boekingen te stimuleren." websiteOnderdelen={[{
    icon: 'BedDoubleIcon',
    title: 'Kamers & Suites',
    description: "Prachtige presentatie van je kamers met grote foto's, faciliteiten en duidelijke prijzen."
  }, {
    icon: 'MapPinIcon',
    title: 'Omgeving',
    description: 'Informatie over bezienswaardigheden, natuur en activiteiten in de buurt om de bestemming te verkopen.'
  }, {
    icon: 'UtensilsIcon',
    title: 'Faciliteiten',
    description: 'Uitgelichte informatie over ontbijt, restaurant, wellness, fietsverhuur of parkeren.'
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Direct boeken',
    description: 'Een prominente boekingsmodule om gasten te verleiden direct via jouw site te boeken in plaats van via Booking.com.'
  }]} functionaliteiten={[{
    icon: 'CalendarCheckIcon',
    title: 'Boekingssysteem (PMS)',
    description: 'Koppeling met systemen zoals Mews, RoomRaccoon, of een eigen WordPress boekingsmodule.'
  }, {
    icon: 'CameraIcon',
    title: 'Snelle fotogalerijen',
    description: 'Geoptimaliseerde, razendsnelle galerijen om de sfeer van je accommodatie perfect over te brengen.'
  }, {
    icon: 'MessageSquareIcon',
    title: 'Meertaligheid',
    description: 'Optie voor meerdere talen (NL, EN, DE) om ook internationale toeristen aan te trekken.'
  }]} siblingClusters={[{
    name: 'Restaurant',
    slug: 'restaurant'
  }, {
    name: 'Café & Lunchroom',
    slug: 'cafe-lunchroom'
  }, {
    name: 'Afhaal & Bezorg',
    slug: 'afhaal-bezorg'
  }]} faqs={[{
    q: 'Hoe zorg ik voor meer directe boekingen (minder Booking.com)?',
    a: 'We richten de website conversiegericht in met een opvallende boekingsmodule en communiceren duidelijk de voordelen van direct boeken (bijv. beste prijsgarantie of gratis ontbijt).'
  }, {
    q: 'Kunnen jullie koppelen met ons huidige reserveringssysteem?',
    a: 'Ja, we kunnen de booking engine van vrijwel elk Property Management System (PMS) of Channel Manager integreren in de website.'
  }, {
    q: 'Wat kost een website voor een B&B of hotel?',
    a: 'Een professionele website start vanaf €1.500. Wil je meertaligheid of een complexe PMS-integratie, dan maken we een offerte op maat.'
  }, {
    q: 'Kan de website in meerdere talen?',
    a: 'Zeker. We kunnen de website meertalig opzetten (bijv. Nederlands, Engels en Duits) zodat je ook buitenlandse toeristen optimaal bedient.'
  }]} data-id="element-1082" />;
}